var _circle, _path, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVpPerson2 = function SvgVpPerson2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 63,
    cy: 63.465,
    r: 62.5,
    fill: "#8CB3DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.36 61.043h59.081A62.524 62.524 0 0 0 84.626 4.827L66.359 61.043ZM66.36 65.926l18.266 56.216a62.533 62.533 0 0 0 40.825-56.216H66.359ZM61.716 67.435l-47.808 34.734a62.598 62.598 0 0 0 66.074 21.484L61.716 67.435ZM11.034 28.748a62.537 62.537 0 0 0 0 69.473l47.82-34.737-47.82-34.736ZM61.716 59.534 79.982 3.318a62.468 62.468 0 0 0-66.074 21.485l47.808 34.731Z",
    fill: "#1C7CE5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.375,
    cy: 63.84,
    r: 46.875,
    fill: "#F8F8F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vp-person-2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.766 46.087c-1.322-1.715-2.663-2.4-3.366-2.662-.112-.047-.103-.216.019-.234l.984-.15c.094-.01.132-.122.085-.188-.966-1.312-3.656-2.775-6.956-2.887-5.532 0-7.575 2.812-7.875 4.2a.66.66 0 0 1-.629.515c-1.2.056-3.562.966-1.48 7.697l.346.31h2.09v-1.416l2.044-1.125.216-1.678h8.278l.834 2.11 1.35.468v1.331h2.579a6.84 6.84 0 0 1 1.472-4.294c.468-.59.468-1.415.009-1.997Z",
    fill: "#BBDAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.766 46.087c-1.322-1.715-2.663-2.4-3.366-2.662-.112-.047-.103-.216.019-.234l.984-.15c.094-.01.132-.122.085-.188-.966-1.312-3.656-2.775-6.956-2.887-5.532 0-7.575 2.812-7.875 4.2a.66.66 0 0 1-.629.515c-1.2.056-3.562.966-1.48 7.697l.346.31h2.09v-1.416l2.044-1.125.216-1.678h8.278l.834 2.11 1.35.468v1.331h2.579a6.84 6.84 0 0 1 1.472-4.294c.468-.59.468-1.415.009-1.997Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.175 80.428h4.603v6.666l.722.872h24l.778-.582v-6.73h4.153l.882-.666V75.44c0-2.672-1.707-4.997-3.77-5.85-.29-.113-3.75-1.453-6.468-2.503l-1.04.253-1.922.937h-9.516l-1.64-1.21h-1.05l-6.45 2.523c-1.613.665-3.77 2.756-3.77 5.85v4.546l.488.441Z",
    fill: "#99EDBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.523 65.616a.687.687 0 0 1-.16-.441v-2.287l-.431-.188h-7.013l-.271.178v2.297a.67.67 0 0 1-.16.45v.319l2.466 2.043-.14.488.102.272h3.188l.206-.375-.16-.534 2.382-1.866-.01-.356Z",
    fill: "#FED1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 62.69h-3.59l-.272.179v2.297a.67.67 0 0 1-.16.45v.318l2.466 2.044-.14.488.103.271H62.5v-6.046Z",
    fill: "#FFBC85"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.178 68.728h2.644v19.238h-2.644V68.728Z",
    fill: "#57C975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.178 68.728H62.5v19.238h-1.322V68.728ZM65.107 70.228a.678.678 0 0 0 1.003.14l3.965-3.29c-1.687-.656-3.093-1.2-3.272-1.266a.687.687 0 0 1-.28-.206l-2.429 2.025a.683.683 0 0 0-.131.91l1.144 1.687ZM58.89 70.378a.685.685 0 0 0 1.004-.14l1.144-1.688a.683.683 0 0 0-.132-.91l-2.428-2.015a.807.807 0 0 1-.131.122l-3.44 1.322 3.984 3.31ZM45.175 80.428h2.588v-5.54c0-2.963 1.312-4.885 2.446-5.991l-1.762.684c-1.603.675-3.76 2.766-3.76 5.86v4.546l.488.441Z",
    fill: "#57C975"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M60.606 44.681a.68.68 0 0 0 .629-.515c.234-1.088 1.547-3.057 4.78-3.853a12.12 12.12 0 0 0-2.483-.347c-5.532 0-7.575 2.812-7.875 4.2a.66.66 0 0 1-.629.515c-1.2.056-3.562.966-1.48 7.697l.346.31h2.09v-1.416l2.044-1.125.216-1.678h.066c-.207-3.206 1.378-3.74 2.296-3.788Z",
    fill: "#35495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.281 54.647c0 1.612 1.425 2.925 3.235 2.644l.272-.347v-4.575l-.272-.375c-1.82-.263-3.235 1.04-3.235 2.653Z",
    fill: "#FED1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.297 54.647c0-1.013.562-1.903 1.425-2.353l-.206-.29c-1.81-.273-3.235 1.03-3.235 2.643 0 1.612 1.425 2.925 3.235 2.644l.215-.282a2.65 2.65 0 0 1-1.434-2.362Z",
    fill: "#FFBC85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.457 52.003-.234.216v4.81l.234.262c1.819.271 3.234-1.041 3.234-2.644 0-1.65-1.65-2.86-3.234-2.644Z",
    fill: "#FED1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.238 52.35a2.93 2.93 0 0 0-1.781-.347l-.234.216v4.81l.234.262a2.875 2.875 0 0 0 1.781-.272V52.35Z",
    fill: "#FFBC85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.175 79.987c-.375 0-.675.3-.675.675v7.304h4.556c.694 0 1.257-.563 1.257-1.257v-6.722h-5.138ZM49.825 79.987h-5.138v6.722c0 .694.563 1.257 1.257 1.257H50.5v-7.304c0-.375-.3-.675-.675-.675Z",
    fill: "#FED1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.809 50.465a1.3 1.3 0 0 1-1.303-1.303c0-.665-.45-1.246-1.088-1.406a15.689 15.689 0 0 0-6.984-.197v9.535c0 3.028 1.772 5.465 4.256 6.515.169.075.337.14.506.197a6.41 6.41 0 0 0 1.106-.375 6.84 6.84 0 0 0 4.163-6.3v-6.01a.664.664 0 0 0-.656-.656Z",
    fill: "#FFE5C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7 63.422c-2.428-1.031-4.163-3.422-4.163-6.366v-9.534c-.328.066-.666.14-.994.225a1.463 1.463 0 0 0-1.087 1.406 1.3 1.3 0 0 1-1.303 1.303.648.648 0 0 0-.647.647v6.019a6.826 6.826 0 0 0 4.162 6.3c1.566.694 3.385.722 4.828.29a6.245 6.245 0 0 1-.796-.29Z",
    fill: "#FED1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.763 79.987h-3.075v6.722c0 .694.562 1.257 1.256 1.257h1.819v-7.979Z",
    fill: "#FFBC85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vp-person-2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(38.5 39.966)",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgVpPerson2;